<template>
  <div>
    <p>Auditing captures a copy of every successful message processed by your NServiceBus endpoints, allowing you to:</p>
    <ul>
      <li><strong>Display and discover messages</strong> - View processed messages in your system</li>
      <li><strong>Track message flow</strong> - See the complete journey of messages through your system</li>
      <li><strong>View the sequence of events</strong> - Understand how messages are processed over time</li>
      <li><strong>Visualize saga state</strong> - Monitor and debug your saga workflows</li>
      <li><strong>Debug issues</strong> - Inspect message contents and headers for troubleshooting</li>
    </ul>
  </div>
</template>
